// extracted by mini-css-extract-plugin
module.exports = {"popupContainer":"Loader_popupContainer__25nI-","blurBg":"Loader_blurBg__1Jlz8","Loader":"Loader_Loader__2At3v","animFirst":"Loader_animFirst__3Fb7h"};